import { translate } from '@/domains/core/localization/translate';
export const {
  pageName
} = translate({
  "pageName": "ManoMano: Online DIY, home improvement and gardening products"
});